import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";

function PurchaseEmailDialog({
  open,
  mode,
  value,
  submitting,
  onChange,
  onSubmit,
  onTryAgain,
}) {
  const isNotFound = mode === "notFound";

  return (
    <Dialog
      open={open}
      onClose={() => {}}
      aria-labelledby="sd-leads-purchase-title"
      fullWidth
      maxWidth="sm"
      PaperProps={{ className: "sd-leads-dialog" }}
    >
      <DialogContent className="sd-leads-dialog__content">
        {isNotFound ? (
          <>
            <h2 id="sd-leads-purchase-title" className="sd-leads-dialog__title">
              Still cannot locate
            </h2>
            <p className="sd-leads-dialog__copy">
              We still cannot locate a Smart Directory AI plan for that email.
              Please try again, or contact our support for help.
            </p>
            <div className="sd-leads-dialog__actions">
              <button type="button" className="sd-leads-dialog__btn" onClick={onTryAgain}>
                Try again
              </button>
            </div>
          </>
        ) : (
          <form onSubmit={onSubmit}>
            <h2 id="sd-leads-purchase-title" className="sd-leads-dialog__title">
              We cannot locate a Smart Directory email
            </h2>
            <p className="sd-leads-dialog__copy">
              Please enter your Smart Directory AI purchase email — the email you
              used to purchase Smart Directory AI — below.
            </p>
            <label className="sd-leads-dialog__label" htmlFor="sd-leads-purchase-email">
              Purchase email
            </label>
            <input
              id="sd-leads-purchase-email"
              className="sd-leads-dialog__input"
              type="email"
              autoComplete="email"
              required
              value={value}
              onChange={(e) => onChange(e.target.value)}
              disabled={submitting}
            />
            <div className="sd-leads-dialog__actions">
              <button type="submit" className="sd-leads-dialog__btn" disabled={submitting}>
                {submitting ? "Checking…" : "Continue"}
              </button>
            </div>
          </form>
        )}
      </DialogContent>
    </Dialog>
  );
}

export default PurchaseEmailDialog;
